module.exports = __webpack_public_path__ + "img/top_left.4db30ddd.svg";